import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Col
} from "reactstrap";
import axios from "axios";
import { useCurrentRoute, useNavigation } from "react-navi";
import { useFormInput } from "../../hooks/generalHooks";
import Container from "../components/Container";
import machineService from "../../services/api/machineService";

export function MachineForm(props) {
  const [machineIdExists, setMachineIdExists] = useState(false);
  const [_id, setId] = useState(null);

  const machineId = useFormInput("");
  const machineName = useFormInput("");

  const route = useCurrentRoute();
  const navigation = useNavigation();

  useEffect(() => {
    if (route.data) {
      const { data } = route;
      machineId.setValue(data.machineId);
      machineName.setValue(data.machineName);
      setId(data._id);
    }
  }, [route.data]);

  function handleReset(event) {
    machineName.setValue("");
    if (!route.data.machineId) {
      machineId.setValue("");
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    await axios
      .get(process.env.REACT_APP_API_URL + "machines/".concat(machineId))
      .then(response => {
        if (response.status !== 204 && props.data === "") {
          setMachineIdExists(true);
        } else {
          setMachineIdExists(false);
        }
      });

    if (machineIdExists) return;

    const data = new FormData();

    // Adding data to form
    data.append("machineId", machineId.value);
    data.append("machineName", machineName.value);

    // if this exists it means we're in edit mode
    if (!route.data.machineId) {
      machineService.createMachine(data);
    } else {
      data.append("_id", _id);
      machineService.updateMachine(_id, data);
    }
    navigation.navigate("/");
  }

  const machineIdExistsFeedback = machineIdExists ? (
    <FormFeedback>Machine ID already exists.</FormFeedback>
  ) : null;

  return (
    <Container title="Please fill in the form below">
      <hr className="hr-black" />
      <Form onSubmit={handleSubmit}>
        <fieldset>
          <FormGroup row>
            <Col>
              <Label for="machineId">Machine ID</Label>
              <Input
                disabled={route.data.machineId}
                invalid={machineIdExists}
                required
                type="number"
                name="machineId"
                id="machineId"
                {...machineId.formProps}
              />
              {machineIdExistsFeedback}
            </Col>
            <Col>
              <Label for="machineName">Machine name</Label>
              <Input
                required
                type="text"
                name="machineName"
                id="machineName"
                {...machineName.formProps}
              />
            </Col>
          </FormGroup>
        </fieldset>

        <FormGroup check row className=" mb-3 d-flex justify-content-center">
          <Col>
            <Button
              outline
              className="btn-black btn-block btn btn-outline-dark"
              type="submit"
            >
              Submit
            </Button>
          </Col>
          <Col>
            <Button
              outline
              className="btn-red btn-block btn btn-outline-danger"
              type="reset"
              onClick={handleReset}
            >
              Reset
            </Button>
          </Col>
        </FormGroup>
      </Form>
    </Container>
  );
}

export default MachineForm;



// WEBPACK FOOTER //
// ./src/views/machine/machineform.jsx